<template>
  <div>



      <!-- Sharing section -->
    <div v-if="bundleConfigEditFlag & dashboardFlags.evsensAdminFlag===true" class="row">
      <div class="col-xs-12">
        <config-sharing-list  :sharingListData="{sharingType:'Channel'}" ></config-sharing-list>
      </div>
    </div>


      <div v-if="dashboardFlags.evsensAdminFlag===true" class="row">
        <div class="col-xs-12">
          <div class="block block-bordered">
            <div class="block block-themed">
            <div class="block-header bg-muted">
                  <ul  class="block-options">
                      <li v-if="flagDisplayFilter===0">
                          <button type="button" @click="toggleDisplayFilter()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>
                      <li v-if="flagDisplayFilter">
                          <button  type="button" @click="toggleDisplayFilter()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>
                  </ul>
              <h2 class="block-title" @click="toggleDisplayFilter()"><i class="fa fa-filter fa-1x push-5-r "></i>{{ sectionLabelDeviceFilter[actualLanguage] }}</h2>
            </div>

            <div v-if="flagDisplayFilter===-1" class="block-content">
              <div  class="row items-push">
                <div class="col-xs-12">
                  <div v-for = "(categoryList ,index) in actualBundle.channelsAttributes">
                      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                          <div class="form-group">
                              <label class="col-xs-12" for="example-multiple-select"><i class="fa fa-tags fa-1x push-5-r "></i>{{categoryList.title}}</label>
                                <div class="col-sm-12">
                                    <select  class="form-control" v-model="attributesFiltersChoice[index]" id="example-multiple-select" name="example-multiple-select" size="4" multiple>
                                        <option v-for= "(element, index2) in attributesFilters[index]" :value="element">{{element}}</option>
                                    </select>
                                </div>
                          </div>
                      </div>
                  </div>
                </div>
                
                <div class="col-xs-12">
                  <div class="col-xs-12 col-sm-6">
                    <button type="button" style="color:white" @click="resetDisplayFlag()" class="btn btn-danger"><i class="fa fa-eraser fa-1x push-5-r "></i>{{ buttonLabelEraseFilter[actualLanguage] }}</button>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <button type="button" @click="applyFilter()" class="btn btn-success align-right" ><i class="fa fa-filter fa-1x push-5-r "></i>{{ buttonLabelApplyFilter[actualLanguage] }}</button>
                  </div>
                </div>
              </div>
            </div>

        </div>
      </div>
      </div>
    </div>




  <div v-if = "showListOfChannel">
    <div v-for="(flag,index) in channelDisplayFlag">
      <div v-if="flag" class="col-xs-12">

          <config-channel v-if="actualBundle.channels[index].FrontendTemplates.componentChannelConfig==='EVA_V1P00'" :channelIndex="index" ></config-channel>

          <config-channel-api-dev-v1p00 v-if="actualBundle.channels[index].FrontendTemplates.componentChannelConfig==='ApiDevice_V1P00'" :channelIndex="index" ></config-channel-api-dev-v1p00>
      </div>
    </div>

  </div>


</div>


</template>

<script>

import _ from 'underscore'
import {mapState, mapActions,mapGetters} from 'vuex'
import Spinner from '../../components/Spinner.vue'
import ConfigChannel from './ConfigChannel'
import ConfigChannelApiDevV1p00 from './ConfigChannelApiDevV1p00'
import ConfigSharingList from './SubComponent/ConfigSharingList'

export default {
  //props: ['channelIndex'],
  components: {
    Spinner,
    ConfigChannel,
    ConfigChannelApiDevV1p00,
    ConfigSharingList
  },
  data() {
    return {    
      actualLanguage : "FR",
      showListOfChannel : true,
      flagDisplayFilter : 0,
      attributesFilters : [],
      channelDisplayFlag : [],
      attributesFiltersChoice : [],
      channelCount : 0,
      defaultBundleSelected: true,

      sectionLabelDeviceFilter:{FR: "Filtres d'affichage des appareils", EN: 'Display devices filters'},
      buttonLabelEraseFilter:{FR: "Effacer les filtres appliqués", EN: 'Reset applied filters'},
      buttonLabelApplyFilter:{FR: "Appliquer les filtres", EN: 'Apply filters'},

      bundleConfigEditFlag : false,
    
    }
  },


  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','groupArborescence','actualBundle','dashboardFlags']),
  },
  watch: {
    actualBundle(){
        //this.resetDisplayFlag()
        //this.generatesFiltersList()
        //console.log('---Watch actual bundle---')
        this.showListOfChannel = false
        this.resetDisplayFlag()
        this.showListOfChannel = true
    },
    groupArborescence(){
      //console.log('---Watch arborescence---')
      this.showListOfChannel = false
      this.resetDisplayFlag()
      this.showListOfChannel = true
    }
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

   toggleDisplayFilter(){
      this.flagDisplayFilter = ~this.flagDisplayFilter
    },

    resetDisplayFlag(){
      this.channelDisplayFlag = []
      var previousDisplayFilter = this.flagDisplayFilter
      this.showListOfChannel = false
      this.flagDisplayFilter = 0
      for(var m=0;m<this.actualBundle.channels.length;m++){
        this.channelDisplayFlag[m]=true
      }
      this.generatesFiltersList()
      this.showListOfChannel = true
      this.flagDisplayFilter = previousDisplayFilter

      this.channelCount = this.actualBundle.channels.length

    },

    generatesFiltersList(){
        this.attributesFilters = []
        this.attributesFiltersChoice = []
          for(var attrList=0;attrList<this.actualBundle.channelsAttributes.length;attrList++){
            this.attributesFilters.push([])
            this.attributesFiltersChoice.push([])
            for(var m=0;m<this.actualBundle.channels.length;m++){
              if(this.channelDisplayFlag[m]==true){
                if(this.actualBundle.channels[m].Attributes[attrList] != "ND")
                {
                  if(this.attributesFilters[attrList].indexOf(this.actualBundle.channels[m].Attributes[attrList])<0)
                  {
                    this.attributesFilters[attrList].push(this.actualBundle.channels[m].Attributes[attrList])
                  }
                }
              }
            }
          }
    },

    applyFilter(){
      this.showListOfChannel = false
      this.flagDisplayFilter = 0
      for(var m=0;m<this.actualBundle.channels.length;m++){

        for(var attrList=0;attrList<this.actualBundle.channelsAttributes.length;attrList++){
          if(this.attributesFiltersChoice[attrList].length > 0)
          {
            if(this.attributesFiltersChoice[attrList].indexOf(this.actualBundle.channels[m].Attributes[attrList])>=0)
            {
              this.channelDisplayFlag[m]=true
            }
            else{
              this.channelDisplayFlag[m]=false
            }
          }
        }
      }
      this.generatesFiltersList()
      this.flagDisplayFilter = -1
      this.showListOfChannel = true
    },



    openChannel(channelIndex){
        this.channelSelected = true
    },
    closeChannel(){
        this.channelSelected = false
    },


    findPermissionItemValue(permissionList,idToFind){
        var value = false
        for (var n = 0; n < permissionList.length; n++){
          if(permissionList[n].id == idToFind)
          {value = permissionList[n].value}
        }
        return value
    }, 


  },

  mounted() {
    //Retirer l'inversion puisque le composant PortGraph effectue l'inversion sur la variable 
    //this.tableData = this.portData.reverse();
    //this.tableData = this.portData;

    this.resetDisplayFlag()

    if(localStorage.language){this.actualLanguage =  localStorage.language}
      else{this.actualLanguage = 'FR'}

    this.bundleConfigEditFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle,'bundleConfigEdit')

    this.defaultBundleSelected = this.actualBundle.bundle_id.includes(':DefaultBundle')

    //console.log("------TEMPO BUNDLE------")
    //console.log(this.actualBundle)



  },


}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// ConfigChannelList.vue?5b2118ca